import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Get } from "../../../../../Request";

export const useStatusAthelets = () => {
  const {
    user: { item },
  } = useSelector(state => state);
  const [loading, setLoading] = useState({
    list: true,
    pa: true,
    deative: true,
  });
  const [data, setData] = useState({});
  const [status, setStatus] = useState("active");
  const [modal, setModal] = useState({ visible: false });
  const getActive = data => {
    console.log(data);
    setLoading({ list: true });
    Get({
      url: "/manager/activeathlete",
      data: { ...data, item_id: item[0].id },
    }).then(response => {
      setData(response);
      setLoading({ list: false });
    });
  };

  const getDeactive = data => {
    setLoading({ deative: true });
    Get({
      url: "/manager/deactiveathlete",
      data: { ...data, item_id: item[0].id },
    }).then(response => {
      setData(response);
      setLoading({ deative: false });
    });
  };
  const { reserve_id } = useParams();
  const getListPA = id => {
    setLoading({ pa: true });
    Get({
      url: "/manager/activeathlete_pa_list",
      data: { reserve_id },
    }).then(response => {
      setData(response);
      setLoading({ pa: false });
    });
  };
  const paginateActive = (page, limit) => {
    getActive({ page, limit });
  };
  const paginateDeaActive = (page, limit) => {
    getDeactive({ page, limit });
  };
  const searchHandlerActive = (search, limit) => {
    getActive({ search, limit });
  };
  const searchHandlerDeactive = (search, limit) => {
    getDeactive({ search, limit });
  };
  return {
    data,
    getActive,
    getDeactive,
    loading,
    status,
    setStatus,
    modal,
    setModal,
    getListPA,
    paginateActive,
    paginateDeaActive,
    searchHandlerActive,
    searchHandlerDeactive,
  };
};
export const useAthelets = () => {
  const {
    user: { item },
  } = useSelector(state => state);
  const [loading, setLoading] = useState({ list: true });
  const [data, setData] = useState({});

  const getAthelets = data => {
    setLoading({ list: true });
    Get({
      url: "/manager/athlete",
      data: { ...data, item_id: item[0].id },
    }).then(response => {
      setData(response);
      setLoading({ list: false });
    });
  };
  const searchHandler = search => {
    getAthelets({ search });
  };
  return {
    data,
    getAthelets,
    loading,
    searchHandler,
  };
};
